module.exports = __webpack_public_path__ + "assets/denomination-on.7d189dbf.svg";